export default __webpack_public_path__ + "static/media/gewonnen.3b060e79.svg";